import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ variant = 'default', className = '', tenantSlug = null }) => {
  // Variants: 'default', 'minimal', 'transparent'
  const baseStyles = "text-center text-sm";
  
  const variants = {
    default: "py-3 border-t border-gray-200 bg-gray-50 text-gray-500",
    minimal: "py-2 text-gray-400",
    transparent: "py-3 text-gray-500"
  };

  // Generate policy links based on tenant context
  const getPolicyLink = (type) => {
    if (tenantSlug) {
      return `/${tenantSlug}/policy/${type}`;
    }
    return `/policy/${type}`;
  };

  return (
    <footer className={`${baseStyles} ${variants[variant]} ${className}`}>
      {/* Policy Links */}
      <div className="flex justify-center gap-4 mb-2">
        <Link 
          to={getPolicyLink('privacy')} 
          className="text-gray-500 hover:text-blue-600 transition-colors"
          data-testid="footer-privacy-link"
        >
          Privacy Policy
        </Link>
        <span className="text-gray-300">•</span>
        <Link 
          to={getPolicyLink('terms')} 
          className="text-gray-500 hover:text-blue-600 transition-colors"
          data-testid="footer-terms-link"
        >
          Terms of Use
        </Link>
        <span className="text-gray-300">•</span>
        <Link 
          to={getPolicyLink('refund')} 
          className="text-gray-500 hover:text-blue-600 transition-colors"
          data-testid="footer-refund-link"
        >
          Refund Policy
        </Link>
      </div>
      <p>
        © 2026 cloudcampus.site | Powered by{' '}
        <a 
          href="https://www.ncriptech.com/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-700 hover:underline font-medium"
        >
          ncriptech
        </a>
      </p>
    </footer>
  );
};

export default Footer;
